import React from 'react';
import { withApollo } from 'react-apollo';
import { Jumbotron } from 'reactstrap';
import { HEART } from '../../assets/Images';

const styles = {
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  logo: {
    marginBottom: 30,
    width: 100,
  },
  title: {
  },
};

const SAVLovebox = () => (
  <Jumbotron style={styles.container}>
    <img alt="logo" src={HEART} style={styles.logo} />
    <h1 style={styles.title}>Welcome in Internal Lovebox Tools</h1>
  </Jumbotron>
);

export default withApollo(SAVLovebox);



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/sav-lovebox.js